export default class Pararax{
    constructor(inc){

        this.$prarax = document.querySelectorAll('.js__psc');
        this.paraPoint = [];
        this.paraNum = this.$prarax.length;

        /*  ステータスをセット */
        this.status = [];

        for(var i=0; this.paraNum>i; i++){
            var $p = this.$prarax[i];

            this.status[i] = {
                rate : $p.getAttribute('data-rate'),
                type : ""
            }

            if($p.classList.contains("js__dir-y")){
                this.status[i].type = "dir-y";
            }else if($p.classList.contains("js__dir-x")){
                this.status[i].type = "dir-x";
            }else{
                this.status[i].type = "dir-default";
            }

        }

        // this.datGUI();

    }
    check(inc,winH,param){

        if(param.displayType === 'sp' || Useragnt.mobile || Useragnt.tablet || this.paraNum === 0) return;
        //if(param.displayType === 'sp' || Useragnt.edge || Useragnt.ie || Useragnt.mobile || Useragnt.tablet) return;

        for(var i=0; this.paraNum>i; i++){

            if(this.paraPoint[i].start < inc && this.paraPoint[i].end > inc  ) {
                let $p = this.$prarax[i];

                let pInc = ( inc - this.paraPoint[i].base ) * this.status[i].rate;

                switch (this.status[i].type){
                    case "dir-y":
                        TweenMax.set(this.$prarax[i],{
                            "y":-pInc
                        });
                        break;
                    case "dir-x":
                        TweenMax.set(this.$prarax[i],{
                            "x":-pInc
                        });
                        break;
                    default :
                        break;
                }

            }

        }
    }

    resize (winH) {
        this.paraPoint = [];
        for (var i = 0; i < this.paraNum; i++) {

            let $p = this.$prarax[i];

            this.paraPoint[i] = {
                base  : $p.getBoundingClientRect().top,
                start : $p.getBoundingClientRect().top - winH,
                end   : $p.getBoundingClientRect().top + winH,
            }

        }
    }


}